import React, { useCallback, useEffect, useState } from 'react'
// import { ModalBody, ModalWrapper } from './SelectGroupPopupStyled'
import { inject, observer } from 'mobx-react'
import { Button, message, Popconfirm, Select, Space, Tag, Tooltip } from 'antd'
import {
  CloseOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import SelectGroupBox from './SelectGroupBox'
import { ModalWrapper } from '../UserGroupPage/AddUserGroupModal/AddUserGroupModalStyled'
import { ModalBody } from '../../components/SelectGroupPopup/SelectGroupPopupStyled'
import { blue, yellowPrimary } from '../../color'
import { AvatarHasName } from '../../components/Common/Avatar'
import EmptyContent from '../../components/EmptyContent'
import SpinnerInlineComponent from '../../components/SpinnerInlineComponent'
import { ASSIGNEE_TYPE } from '../../constants'
import { EmptyText } from '../../components/Common/CellText'

const { Option } = Select

const SelectRiskGroupPopup = props => {
  const {
    riskUnitUserStore,
    isVisibleSelectGroupPopup,
    handleSubmitSelectGroup,
    handleCancelSelectGroup,
    selectPeopleStore,
    clearSelectGroup,
    loadingAnimationStore,
    groupType,
    onlySelectOne,
    noLoadSelectData,
    authenticationStore,
    companyStore,
    onlySelectOneUser,
    onlySelectUser,
    selectedListAndType,
    setSelectedListAndType,
    setSelectedList,
    riskStore,
    isPhieuruiro,
  } = props

  const {
    assigneePopupType,
    selectGroupData,
    setSelectGroupData,
    setGroupList,
    originGroupList,
    companyCode,
    selectUserData,
    setSelectUserData,
    selectDepartmentData,
    setSelectDepartmentData,
  } = selectPeopleStore
  const { companyList } = companyStore
  const { riskId } = useParams()
  const [disableGroupList, setDisableGroupList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [prevSelectedGroupData, setPrevSelectedGroupData] = useState([])
  const handleRemoveSelect = useCallback(
    group => {
      setSelectGroupData({
        ...selectGroupData,
        [assigneePopupType]: selectGroupData[assigneePopupType].filter(
          el => el.id !== group.id
        ),
      })
      setSelectUserData({
        ...selectUserData,
        [assigneePopupType]: selectUserData[assigneePopupType].filter(
          el => el.id !== group.id
        ),
      })
    },
    [assigneePopupType, selectGroupData]
  )

  useEffect(() => {
    setPrevSelectedGroupData(selectGroupData[assigneePopupType])
  }, [isVisibleSelectGroupPopup])

  const lmao = riskStore.riskDetail?.tiers?.[2]?.approvals?.[1]?.peoples
  const updateTierApprovalWhenSelectedUserDataChange = async () => {
    try {
      const riskTierCode =
        riskStore.riskDetail?.tiers?.[2]?.approvals?.[1]?.peoples?.[0]
          ?.risk_tier_approval_code ||
        riskStore.riskDetail?.tiers?.[2]?.approvals?.[1]?.code

      loadingAnimationStore.showSpinner(true)

      // Tạo payload mới
      const approvalPayload = {
        approval_people: {
          new_items: [],
          remove_items: [],
        },
      }

      // Lọc ra những người đã có trong lmao nhưng không còn xuất hiện trong selectUserData
      if (lmao) {
        const currentUsers = selectUserData[assigneePopupType].map(
          item => item.id
        )

        // Lọc new items chỉ chứa những người chưa có trong lmao
        selectUserData[assigneePopupType].forEach(item => {
          // Nếu user mới không có trong danh sách lmao, thêm vào new_items
          if (!lmao.some(user => user.username === item.id)) {
            approvalPayload.approval_people.new_items.push({
              assignee_code: item.id,
              department_code: null,
            })
          }
        })

        // Lọc ra những người cũ không có trong danh sách selectUserData
        lmao.forEach(user => {
          if (!currentUsers.includes(user.username)) {
            approvalPayload.approval_people.remove_items.push({
              assignee_code: user.username,
              department_code: null,
            })
          }
        })
      }

      // Gửi request cập nhật
      await riskStore.updateTierApproval(riskTierCode, approvalPayload)
      await riskStore.getRiskDetail(riskId)
      message.success(`Cập nhật thành công`)
    } catch (error) {
      // message.error(error.message ?? `Đã có lỗi xảy ra!`)
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    if (!assigneePopupType) return
    const selectedGroupList = [
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ]
    setDisableGroupList(
      selectedGroupList
        .filter(el => el.permission !== assigneePopupType)
        .map(el => el.id)
    )
  }, [assigneePopupType])

  useEffect(() => {
    setGroupList(originGroupList)
  }, [isVisibleSelectGroupPopup])

  useEffect(() => {
    if (noLoadSelectData) return
    ;(async () => {
      if (companyCode) {
        if (authenticationStore.currentUser) {
          try {
            setIsLoading(true)
            await selectPeopleStore.getGroupList(
              groupType,
              authenticationStore.currentCompanyCode()
            )
          } catch (err) {
            // message.error(err.vi || 'Đã có lỗi xảy ra!')
          } finally {
            setIsLoading(false)
          }
        }
      }
    })()
  }, [companyCode])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  const onCompanyChange = value => {
    selectPeopleStore.companyCode = value
  }

  const handleSubmit = () => {
    if (props.setIsSelectUser) {
      props.setIsSelectUser(true)
    }
    updateTierApprovalWhenSelectedUserDataChange()
    handleSubmitSelectGroup()
  }
  return (
    <ModalWrapper
      maskClosable={false}
      okText={'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={700}
      footer={null}
      style={{ top: 20 }}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Select
            notFoundContent={<EmptyContent />}
            onChange={onCompanyChange}
            value={companyCode}
            placeholder={'-- Chọn công ty --'}>
            {companyList.map(item => (
              <Option key={item.code} value={item.code}>
                {item.name}
              </Option>
            ))}
          </Select>
          <Space>
            <Popconfirm
              placement="top"
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không?'}
              onConfirm={() => {
                selectPeopleStore.handleCancelSelectGroup()
                handleCancelSelectGroup()
              }}
              okText="Đồng ý"
              cancelText="Không">
              <Button
                danger
                icon={<WarningOutlined style={{ color: yellowPrimary }} />}>
                Hủy chọn
              </Button>
            </Popconfirm>
            <Button
              type={'primary'}
              onClick={() => {
                if (!isPhieuruiro) {
                  JSON.stringify(selectGroupData[assigneePopupType]) !==
                  JSON.stringify(prevSelectedGroupData)
                    ? handleCancelSelectGroup()
                    : handleSubmit()
                } else {
                  JSON.stringify(selectGroupData[assigneePopupType]) !==
                  JSON.stringify(prevSelectedGroupData)
                    ? handleCancelSelectGroup()
                    : handleCancelSelectGroup()
                }
              }}>
              Đồng ý
            </Button>
            <Tooltip title={'Đóng'}>
              <CloseOutlined
                onClick={async () => {
                  setSelectGroupData({
                    ...selectGroupData,
                    [assigneePopupType]: prevSelectedGroupData,
                  })
                  handleCancelSelectGroup()
                  await selectPeopleStore.handleCancelSelectGroup()
                }}
              />
            </Tooltip>
          </Space>
        </div>
      }
      closable={false}
      forceRender={true}
      visible={isVisibleSelectGroupPopup}>
      <ModalBody>
        <div className={'list-box'}>
          <label
            style={{
              width: 90,
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500,
            }}>
            <UnorderedListOutlined style={{ marginRight: 4, color: blue }} />
            Danh sách:
          </label>
          {selectGroupData[assigneePopupType]?.length > 0 ||
          selectUserData[assigneePopupType]?.length > 0 ? (
            [
              ...(selectGroupData[assigneePopupType] || []),
              ...(selectUserData[assigneePopupType] || []),
            ].map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => handleRemoveSelect(el)}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />
                  }
                />
              </Tag>
            ))
          ) : (
            <EmptyText>
              <span style={{ lineHeight: '34px' }}>
                Chưa có nhóm hoặc người dùng nào được chọn
              </span>
            </EmptyText>
          )}
        </div>
        <div className={'modal-body'} style={{ position: 'relative' }}>
          <SelectGroupBox
            disableGroupList={disableGroupList}
            onlySelectOne={onlySelectOne}
            isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
            onlySelectOneUser={onlySelectOneUser}
            onlySelectUser={onlySelectUser}
          />
          <SpinnerInlineComponent
            sizeSpin={'small'}
            isLoading={isLoading}
            noBackground
          />
          <div />
        </div>
      </ModalBody>
    </ModalWrapper>
  )
}

export default inject(
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore',
  'companyStore',
  'riskUnitUserStore',
  'riskStore'
)(observer(SelectRiskGroupPopup))
